import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", form);
      localStorage.setItem("satish_admin_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen hero-gradient flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="admin-login-card">
        <div className="w-14 h-14 rounded-2xl hero-gradient flex items-center justify-center text-white mx-auto mb-5">
          <Lock className="w-7 h-7" />
        </div>
        <h1 className="font-serif text-2xl font-bold text-navy text-center">Campaign Admin</h1>
        <p className="text-slate-500 text-sm text-center mt-1">Sign in to manage the campaign site.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <Input type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email" />
          <Input type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password" />
          {error && <p className="text-sm text-donate" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full bg-brightblue hover:bg-brightblue-hover text-white font-semibold h-11" data-testid="admin-login-submit">
            {busy ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
